<template>
  <div>
    <p>welcome to the signup page</p>
    <v-container grid-list-xs,sm,md,lg,xl>

      <form @submit.prevent="SignUp()">
        <v-text-field
        justify-center
        v-model="username"
        name="username"
        placeholder="Username"></v-text-field>
        <v-text-field
        justify-center
        v-model="password"
        name="password"
        placeholder="Password"></v-text-field>
        <v-text-field
        justify-center
        v-model="confirmPassword"
        name="confirmPassword"
        placeholder="Confirm Password"></v-text-field>
        <!-- <input v-model="username" type="username" placeholder="Username"> -->
        <!-- <input v-model="password" type="password" placeholder="Password"> -->
        <!-- <input v-model="confirmPassword" type="password" placeholder="Confirm Password"> -->

        <v-btn color="primary" type="submit">Sign-up</v-btn>
      </form>
    </v-container>
  </div>
</template>
<script>
import db from "../database";
import firebase from "firebase";
export default {
  name: "SignUp",
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    SignUp() {
      if (this.password === this.confirmPassword) {
        console.log("The same!");
      } else {
        console.log("different");
      }
    }
  }
};
</script>
